var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "v-card",
        { staticClass: "contenedor-principal" },
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c("v-flex", { attrs: { xs12: "", md4: "" } }, [
                _c(
                  "div",
                  { staticClass: "grey lighten-3 contenedor-sticky" },
                  [
                    _c("div", { staticClass: "title py-3 px-3" }, [
                      _vm._v(
                        "\n            Estructura organizacional\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c("v-divider"),
                    _vm._v(" "),
                    _c("v-treeview", {
                      staticClass: "arbol",
                      attrs: {
                        active: _vm.active,
                        items: _vm.l_unidades,
                        open: _vm.open,
                        activatable: "",
                        "active-class": "primary--text",
                        "open-on-click": "",
                        transition: "",
                        "item-text": "nombre_unidad"
                      },
                      on: {
                        "update:active": function($event) {
                          _vm.active = $event
                        },
                        "update:open": function($event) {
                          _vm.open = $event
                        }
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "prepend",
                          fn: function(ref) {
                            var item = ref.item
                            return [
                              item.children && item.children.length == 0
                                ? _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        color:
                                          item.id == _vm.selected.id
                                            ? "blue"
                                            : ""
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                domain\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          }
                        },
                        {
                          key: "label",
                          fn: function(ref) {
                            var item = ref.item
                            return [
                              _c(
                                "div",
                                {
                                  staticClass: "arbol-label",
                                  on: {
                                    click: function($event) {
                                      return _vm.selectUnidad(item)
                                    }
                                  }
                                },
                                [
                                  _c("v-tooltip", { attrs: { bottom: "" } }, [
                                    _c(
                                      "span",
                                      {
                                        class:
                                          item.id == _vm.selected.id
                                            ? "blue--text font-weight-bold"
                                            : "",
                                        attrs: { slot: "activator" },
                                        slot: "activator"
                                      },
                                      [
                                        _c("b", [
                                          _vm._v(
                                            _vm._s(
                                              "(" + item.sigla.trim() + ")"
                                            )
                                          )
                                        ]),
                                        _vm._v(_vm._s("-" + item.nombre_unidad))
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(_vm._s(item.nombre_unidad))
                                    ])
                                  ])
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs12: "", md8: "", "text-xs-center": "" } },
                [
                  _vm.selected.id == -1
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "title grey--text text--lighten-1 font-weight-light mt-3",
                          staticStyle: { "align-self": "center" }
                        },
                        [_vm._v("\n          Seleccione una unidad\n        ")]
                      )
                    : _c(
                        "v-card",
                        { key: _vm.selected.id },
                        [
                          _c(
                            "div",
                            { staticClass: "mt-2 contenedor-dependencia" },
                            [
                              _c(
                                "ul",
                                { staticClass: "lista-dependencia" },
                                _vm._l(_vm.selected.dependencia, function(
                                  dependencia
                                ) {
                                  return _c(
                                    "li",
                                    {
                                      key: dependencia,
                                      staticClass: "blue--text"
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(dependencia) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                }),
                                0
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("EstructuraUnidad", {
                            attrs: {
                              id_unidad: parseInt(_vm.selected.id),
                              filtros_persona: {},
                              campos_personales: ["nro_item", "cargo", "puesto"]
                            }
                          })
                        ],
                        1
                      )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4fb4c7e0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fb4c7e0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/reportes_lista_personal/components/ArbolUnidades.vue
// module id = null
// module chunks = 